import type { CommandCategory } from 'owa-hotkeys-map';
import { lazyMountAndShowFullOptions } from 'owa-options-view';
import { getCommandCategories, getCommands } from '../utils/MailModuleHotKeys';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

export function getMailHotkeysMapProperties(): {
    commandCategories: CommandCategory[];
    goToOptions: () => void;
    hotkeyCommands: any[];
} {
    const goToOptions = (): void => {
        lazyMountAndShowFullOptions.importAndExecute(
            'general',
            'accessibility',
            undefined /*option*/,
            window,
            getModuleContextMailboxInfo()
        );
    };

    /**
     * KeyboardShortcutsMap requires an array of HotkeyCommands, so convert
     * the object from MailModuleHotKeys to an array.
     */
    return {
        commandCategories: getCommandCategories(),
        goToOptions,
        hotkeyCommands: Object.values(getCommands()),
    };
}
